import { Currency } from '@pancakeswap/sdk'
import { useNetwork } from 'wagmi'
import { getChainId } from 'config/constants/exchange'
import { SWAP, SWAP2 } from 'config/constants/tokens'
import { useRouter } from 'next/router'
import { useCallback } from 'react'
import currencyId from 'utils/currencyId'


export const useCurrencySelectRoute = () => {
  const router = useRouter()
  const { query } = router;
  const { chain } = useNetwork()
  const chainId = getChainId(chain);
  const currencyIdA = query.currencyA || SWAP2[chainId]?.address;
  const currencyIdB = query.currencyB || SWAP[chainId]?.address;

  const handleCurrencyASelect = useCallback(
    (currencyA_: Currency) => {
      const newCurrencyIdA = currencyId(currencyA_)
      if (newCurrencyIdA === currencyIdB) {
        router.replace(`/add/?currencyA=${currencyIdB}&currencyB=${currencyIdA}`, undefined, { shallow: true })
      } else if (currencyIdB) {
        router.replace(`/add/?currencyA=${newCurrencyIdA}&currencyB=${currencyIdB}`, undefined, { shallow: true })
      } else {
        router.replace(`/add/?currencyA=${newCurrencyIdA}&currencyB=${currencyIdB}`, undefined, { shallow: true })
      }
    },
    [currencyIdB, router, currencyIdA],
  )
  const handleCurrencyBSelect = useCallback(
    (currencyB_: Currency) => {
      const newCurrencyIdB = currencyId(currencyB_)
      if (currencyIdA === newCurrencyIdB) {
        if (currencyIdB) {
          router.replace(`/add/?currencyA=${currencyIdB}&currencyB=${newCurrencyIdB}`, undefined, { shallow: true })
        } else {
          router.replace(`/add/?currencyA=${newCurrencyIdB}`, undefined, { shallow: true })
        }
      } else {
        router.replace(`/add/?currencyA=${currencyIdA || 'ETH'}&currencyB=${newCurrencyIdB}`, undefined, { shallow: true })
      }
    },
    [currencyIdA, router, currencyIdB],
  )

  return {
    handleCurrencyASelect,
    handleCurrencyBSelect,
  }
}
